module.exports = __webpack_public_path__ + "img/DE.cc23f204.png";